import React from 'react';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import update from 'react-addons-update';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMUserResource from 'resources/SMUserResource';
import SMRestClient from 'lib/SMRestClient';
import sprintf from 'sprintf';
import SMServiceMessageListView from 'components/notifications/SMServiceMessageListView';
import SMToDoListView from 'components/notifications/SMToDoListView';
import SMNotificationListView from 'components/notifications/SMNotificationListView';
import SMGraphQLClient from 'lib/SMGraphQLClient';
import 'babel-polyfill';
import { companyManagedFragment } from 'fragments';
import SMSubdomainUrlHelper from 'components/helpers/SMSubdomainUrlHelper';

class SMMobileDrawer extends React.Component {

  constructor(props) {
    super(props);
    this.currentPage = this.props.page;
    this.canRequest = true;
    this.isDrawerOpen = false;
    this.state = {
      display: this.props.display,
      listItems: [],

      // news
      badgeNumber: null,
      isOpen: false,
      notificationItems: [],
      announcementItems: [],
      todoItems: [],
      companies: [],
    };

    this.tableViewDidScroll = this.tableViewDidScroll.bind(this);
  }

  componentDidMount() {
    if (SMAppHelper.isMobile()) {
      this.setBadgeNumber();
    }
  }

  setTitleWithUnread(){
    var label = SMFormatHelper.unreadNumberLabel(this.state.badgeNumber);
    if (label) {
      window.document.title = sprintf("(%s) %s", label, window.document.title);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    $(this.refs.tableView).off("scroll", this.tableViewDidScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    $(this.refs.tableView).on("scroll", this.tableViewDidScroll);
  }

  tableViewDidScroll(e){
    SMAppHelper.observeScrollToBottom(e.currentTarget, ()=>{
      this.requestNotificationResource(true);
    });
  }

  setBadgeNumber(){
    if (!this.props.currentUser) return null;
    SMUserResource.getNotifications(this.props.currentUser.username, {per_page:1, filter: "unread"}, (responses, error, xhr)=>{
      var number = xhr.getResponseHeader('X-List-Total-Count');
      var state = {
        badgeNumber: responses.unckecked_notifications_number,
        todoItems: responses.todo_items,
        announcementItems: responses.announcements,
      };
      this.setState(state);
      this.setTitleWithUnread();
    });
  }

  requestNotificationResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    if (!isAppend) this.setState({display: SMConst.Display.Loading});
    var queries = {},
        responseHandler = (responses, error, xhr)=>{
          if(this.state.display == SMConst.Display.Hidden) return;
          this.setState({display: SMConst.Display.Visible});
          if(error || !responses) return;
          var links = SMRestClient.getLinks(xhr),
              notificationItems = this.state.notificationItems;
          if (links["next"]) {
            this.canRequest = true;
          }

          if (isAppend) {
            notificationItems = update(notificationItems, {$push: responses.notifications});
          } else {
            notificationItems = responses.notifications;
          }

          this.currentPage++;
          this.setState({
            badgeNumber: responses.unckecked_notifications_number,
            notificationItems: notificationItems,
            todoItems: responses.todo_items,
            announcementItems: responses.announcements,
          });
        };
    if (this.currentPage != 1) queries["page"] = this.currentPage;

    if (this.state.badgeNumber > 0) {
      SMUserResource.checkNotifications(this.props.currentUser.username, queries, responseHandler);
    } else {
      SMUserResource.getNotifications(this.props.currentUser.username, queries, responseHandler);
    }
  }

  showNotificationList(e) {
    $(document).trigger("SMHideBaloon");
    this.currentPage = 1;
    this.canRequest = true;
    this.requestNotificationResource();
    SMAppHelper.canBodyScroll(false);
    this.closeDrawer(()=>{
      $(this.refs.modal).niftyModal({afterClose: (modal, e)=>{
        this.setState({isOpen: false});
        SMAppHelper.canBodyScroll(true);
        e.preventDefault();
      }});
    });
  }

  async requestResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    if (!isAppend) this.setState({ display: SMConst.Display.Loading });
    let queries = {};
    if (this.currentPage != 1) queries["page"] = this.currentPage;
    SMUserResource.getOwners(this.props.currentUser.username, queries, (responses, error, xhr)=>{
      this.setState({ display: SMConst.Display.Visible });
      if(error || !responses) return;
      let links = SMRestClient.getLinks(xhr),
          listItems = this.state.listItems;
      if (links["next"]) {
        this.canRequest = true;
      }
      listItems = update(listItems, {$push: responses});

      this.currentPage++;
      this.setState({
        listItems: listItems,
      });
    });

    const apiClient = new SMGraphQLClient();
    const query = `
      query {
        viewer {
          companies(filter: MANAGED) {
            results{
              ... on Company {
                ${companyManagedFragment}
              }
            }
          }
        }
      }
    `;

    const obj = await apiClient.request(query);

    if (!obj) return false;
    if (obj.errors) {
      console.log(obj.errors);
      return false;
    }

    this.setState({
      companies: obj.data.viewer.companies.results
    });
  }

  toggleDrawerMenu(e){
    this.isDrawerOpen = !this.isDrawerOpen;
    if (this.isDrawerOpen) {
      if (this.props.currentUser) {
        this.requestResource();
      }
      SMAppHelper.canBodyScroll(false);
    } else {
      SMAppHelper.canBodyScroll(true);
    }
  }

  searchFilterDidUpdate(queries) {
    window.location.href = Routes.search_index_path(queries);
  }

  signUpDidSelect() {
    SMTrackHelper.criteoBasket("", "createUser", 2000, 1);
  }

  closeDrawer(callback) {
    $(this.refs.closeButton).click();
    setTimeout(()=>{
      callback();
    }, 300);
  }

  showBadge(){
    let label = SMFormatHelper.unreadNumberLabel(this.state.badgeNumber);
    if (!label) {
      label = <i className="fa fa-exclamation"></i>;
    }
    return <span className="site-header__drawer-menu-bagde">{label}</span>;
  }

  renderLoggedIn() {
    let currentUser = this.props.currentUser;
    return (
      <div>
        <input onChange={this.toggleDrawerMenu.bind(this)} type="checkbox" className="site-header__drawer-check" id="site-header__drawer" />
        <label className="site-header__drawer-menu-btn" htmlFor="site-header__drawer">
          <i className="fa fa-bars"></i>
        </label>
        <label ref="closeButton" className="site-header__drawer-close-menu" htmlFor="site-header__drawer"></label>
        <nav className="site-header__drawer-menu js-scroller__overflow">
          <ul>
              <li>
                <div className="site-header__drawer-name-box">
                  <img src={currentUser.profile_image} alt={currentUser.name} className="site-header__drawer-user-icon" />
                  <p className="site-header__drawer-name-guest">{I18n.t("dashboard.label_000102")}</p>
                  <p className="site-header__drawer-user-name">{currentUser.name}</p>
                  <p className="site-header__drawer-user-point">{currentUser.point_balance.available_amount}<span className="site-header__drawer-user-point-unit">ポイント</span></p>
                </div>
                <ul>
                  <li className="site-header__drawer-menu-list"><a href="#" onClick={this.showNotificationList.bind(this)}><i className="fa fa-envelope"></i>{I18n.t('service.label_000074')}{this.showBadge()}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.dashboard_index_path()}><i className="fa fa-dashboard"></i>{I18n.t('dashboard.label_000311')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.dashboard_favorite_lists_path()}><i className="fa fa-heart"></i>{I18n.t('dashboard.label_000004')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.dashboard_reservations_path()}><i className="fa fa-file-text-o"></i>{I18n.t('dashboard.label_000005')}</a></li>
                  {/*<li className="site-header__drawer-menu-list"><a href={Routes.dashboard_messages_path()}><i className="fa fa-comment"></i>{I18n.t('dashboard.label_000011')}</a></li>*/}
                  <li className="site-header__drawer-menu-list"><a href={Routes.dashboard_points_available_point_histories_path()}><i className="icon icon-spm-point"></i>{I18n.t('dashboard.label_001100')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.dashboard_settings_account_path()}><i className="fa fa-cog"></i>{I18n.t('dashboard.label_000014')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href="https://help.spacemarket.com/hc"><i className="fa fa-question"></i>{I18n.t('service.label_000077')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.referrals_path()}><i className="fa fa-users"></i>{I18n.t('service.label_000109')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.destroy_user_session_path()}><i className="fa fa-sign-out"></i>{I18n.t('dashboard.label_000008')}</a></li>
                </ul>
              </li>
              {this.state.listItems.map((owner)=>{
                return (
                  <li key={owner.id}>
                    <div className="site-header__drawer-name-box">
                      <img src={owner.profile_image} alt={SMFormatHelper.ownerName(owner)} className="site-header__drawer-user-icon" />
                      <p className="site-header__drawer-name-host">{I18n.t("dashboard.label_000101")}</p>
                      <p className="site-header__drawer-user-name">{SMFormatHelper.ownerName(owner)}</p>
                    </div>
                    <ul>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_path(owner.username)}><i className="fa fa-dashboard"></i>{I18n.t("dashboard.label_000311")}</a></li>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_calendars_path(owner.username)}><i className="fa fa-star"></i>{I18n.t("dashboard.label_000100")}</a></li>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_analytics_path(owner.username)}><i className="fa fa-bar-chart"></i>{I18n.t("dashboard.label_000009")}</a></li>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_reservations_path(owner.username)}><i className="fa fa-file-text-o"></i>{I18n.t("dashboard.label_000005")}</a></li>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_spaces_path(owner.username)}><i className="fa fa-building"></i>{I18n.t("dashboard.label_000012")}</a></li>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_sales_path(owner.username)}><i className="fa fa-usd"></i>{I18n.t("dashboard.label_000013")}</a></li>
                      <li className="site-header__drawer-menu-list"><a href={Routes.owner_dashboard_settings_account_path(owner.username)}><i className="fa fa-cog"></i>{I18n.t('dashboard.label_000014')}</a></li>
                    </ul>
                  </li>
                );
              })}
          </ul>
          {this.state.companies.length > 0 ? <h2 className="site-header__drawer-menu-title">ビジネスアカウント</h2> : null }
          <ul>
            {this.state.companies.map((company)=>{
              return(
                <li className="site-header__drawer-menu-list"><a href={SMSubdomainUrlHelper.businessSummaryUrl(company.username)}>{company.name}</a></li>
              );
            })}
            {currentUser.is_corp ? <li className="site-header__drawer-menu-list"><a href={SMSubdomainUrlHelper.businessBaseUrl()}>ビジネスアカウントを作成</a></li> : null}
          </ul>
        </nav>
        <div className="md-modal-cover md-effect-100" ref="modal">
          <div className="md-content">
            <div className="js-site-header__message-menu--mobile">
              <div ref="tableView" className="site-header__message-menu js-scroller__overflow">
                <SMServiceMessageListView notifications={this.state.announcementItems} />
                <SMToDoListView notifications={this.state.todoItems} />
                <SMNotificationListView notifications={this.state.notificationItems} display={this.state.display} currentUser={currentUser} />
              </div>
              <p className="site-header__message-menu-close">
                <a className="md-close" href="#"><i className="fa fa-times"></i></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderDefault() {
    return (
      <div>
        <input onChange={this.toggleDrawerMenu.bind(this)} type="checkbox" className="site-header__drawer-check" id="site-header__drawer" />
        <label className="site-header__drawer-menu-btn" htmlFor="site-header__drawer">
          <i className="fa fa-bars"></i>
        </label>
        <label ref="closeButton" className="site-header__drawer-close-menu" htmlFor="site-header__drawer"></label>
        <nav className="site-header__drawer-menu js-scroller__overflow">
          <ul>
              <li>
                <div className="site-header__drawer-name-box">
                  <img src={SMRailsBridge.assetPath.userDefaultIconWhite} alt={I18n.t("service.label_000024")} className="site-header__drawer-user-icon" />
                  <p className="site-header__drawer-name-title">{I18n.t("dashboard.label_000102")}</p>
                  <p className="site-header__drawer-user-name">{I18n.t("service.label_000025")}</p>
                </div>
                <ul>
                  <li className="site-header__drawer-menu-list"><a href={Routes.how_it_works_about_index_path()}><i className="fa fa-info-circle"></i>{I18n.t('service.label_000029')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href="https://help.spacemarket.com/hc"><i className="fa fa-question"></i>{I18n.t('service.label_000077')}</a></li>
                  <li className="site-header__drawer-menu-list"><a href={Routes.new_user_session_path()}><i className="fa fa-sign-in"></i>{I18n.t('service.label_000026')}</a></li>
                  <li className="site-header__drawer-menu-list"><a onClick={this.signUpDidSelect.bind(this)} href={Routes.new_user_registration_path()}><i className="fa fa-user"></i>{I18n.t('service.label_000027')}</a></li>
                </ul>
              </li>
          </ul>
        </nav>
      </div>
    );
  }

  render() {
    return(
      <div className="site-header__smp">
        {this.props.currentUser ? this.renderLoggedIn() : this.renderDefault()}
      </div>
    );
  }
}

SMMobileDrawer.defaultProps = {
  display: SMConst.Display.Hidden,
  page: 1,
  perPage: 20,
};
export default SMMobileDrawer;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMMobileDrawer.jsx